<template>
  <div class="bg-navy-50/60 py-20 px-5 lg:px-8 lg:py-28">
    <div class="mx-auto max-w-7xl">
      <div class="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div class="max-w-2xl">
          <p class="eyebrow">Our work</p>
          <h2 class="mt-4 text-4xl font-extrabold tracking-tight text-navy-950 sm:text-5xl">
            The difference, side by side.
          </h2>
          <p class="mt-5 text-lg leading-8 text-navy-600">
            Real jobs, no filters. Drag the slider across each photo to see where we started and where we finished.
          </p>
        </div>
        <a href="#contact" class="btn-primary shrink-0">Get a free quote</a>
      </div>

      <div class="mt-14 grid gap-6 lg:grid-cols-2">
        <BeforeAfter v-for="job in jobs" :key="job.id" v-bind="job" />
      </div>
    </div>
  </div>
</template>

<script setup>
import BeforeAfter from './BeforeAfter.vue'
import before1 from '../assets/2before.webp'
import after1 from '../assets/2after.webp'
import before2 from '../assets/1before.webp'
import after2 from '../assets/1after.webp'

const jobs = [
  { id: 1, before: before1, after: after1 },
  { id: 2, before: before2, after: after2 }
]
</script>
